/**
 * Created by minimus on 02.01.2017.
 */
(function ($) {
  $(document).ready(function () {
    const controller = new $.ScrollMagic.Controller();
    const scenes = [];
    let tlScene;
    let mlScene;
    let blScene;
    let trScene;
    let mrScene;
    let brScene;
    let bmScene;
    let ppScene;

    // Corner Ad
    const xaCorner = samProOptions.xaCorner;

    if (xaCorner.enabled) {
      $('body').peelback({
        adImage: xaCorner.img,
        peelImage: xaCorner.peel,
        clickURL: xaCorner.link,
        smallSize: xaCorner.smallSize,
        bigSize: xaCorner.bigSize,
        track: samProOptions.jsStats,
        aid: xaCorner.aid,
        pid: xaCorner.pid,
        path: samProOptions.ajaxUrl,
        nonce: samProOptions.samProNonce,
        autoAnimate: xaCorner.animate
      });
    }

    // Background Ads
    const xaBackground = samProOptions.xaBackground;
    const body = $(xaBackground.body);
    const path = samProOptions.ajaxUrl;
    const nonce = samProOptions.samProNonce;
    const hits = [];

    if (xaBackground.left.enabled) {
      $(document).mousemove((e) => {
        const target = $(e.target);
        if (target.is(xaBackground.body)) {
          target.css('cursor', 'pointer');
        }
        else {
          $(xaBackground.body).css('cursor', 'initial');
        }
      });
      body.on('click', (e) => {
        const target = $(e.target);
        const docWidth = $(document).width();
        let newWin;
        if (target.is(xaBackground.body)) {
          if (xaBackground.right.enabled) {
            if (e.pageX <= docWidth / 2) {
              $.post(path, {
                action: 'sam_click',
                aid: xaBackground.left.aid,
                pid: xaBackground.left.pid,
                sam_pro_nonce: nonce
              });
              newWin = window.open(xaBackground.left.link);
            }
            else {
              $.post(path, {
                action: 'sam_click',
                aid: xaBackground.right.aid,
                pid: xaBackground.right.pid,
                sam_pro_nonce: nonce
              });
              newWin = window.open(xaBackground.right.link);
            }
          }
          else {
            $.post(path, {
              action: 'sam_click',
              aid: xaBackground.left.aid,
              pid: xaBackground.left.pid,
              sam_pro_nonce: nonce
            });
            newWin = window.open(xaBackground.left.link);
          }
          newWin.focus();
        }
      });

      if (xaBackground.right.enabled) {
        body.css({
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left top, right top',
          backgroundAttachment: 'fixed',
          backgroundImage: 'url("' + xaBackground.left.img + '"), url("' + xaBackground.right.img + '")',
          backgroundSize: 'contain'
        });
        hits.push({aid: xaBackground.left.aid, pid: xaBackground.left.pid});
        hits.push({aid: xaBackground.right.aid, pid: xaBackground.right.pid});
      }
      else {
        body.css({
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center top',
          backgroundAttachment: 'fixed',
          backgroundImage: 'url("' + xaBackground.left.img + '")',
          backgroundSize: 'cover'
        });
        hits.push({aid: xaBackground.left.aid, pid: xaBackground.left.pid});
      }
      $.post(path, {action: 'sam_hits', hits, sam_pro_nonce: nonce});
    }

    // Fixed Ads
    function animateFixed(op, scene) {
      if (op.enabled) {
        const target = $('.' + op.el);
        const aPosition = op.el.split('-', 4);
        const vcOpts = {op1: null, op2: {display: 'flex', duration: op.duration, delay: op.delay}};
        switch (op.animation) {
          case 'fadeIn':
            vcOpts.op1 = op.animation;
            break;
          case 'vertical':
            vcOpts.op1 = {translateY: (1000 + parseInt(op.y, 10)) * ((aPosition[2] === 'top') ? 1 : -1)};
            break;
          case 'horizontal':
            let oProps;
            if (aPosition[2] === 'middle') {
              if (aPosition[3] === 'left') {
                oProps = {left: parseInt(op.x, 10)}
              }
              else oProps = {right: parseInt(op.x, 10)};
            }
            else oProps = {translateX: 1000 + parseInt(op.x, 10)};
            vcOpts.op1 = oProps;
            break;
        }
        if (op.event === 'immediately') {
          target.velocity(vcOpts.op1, vcOpts.op2);
        }
        else {
          switch (op.event) {
            case 'scroll':
              scene = new $.ScrollMagic.Scene({
                duration: 0,
                offset: op.offset,
                reverse: false
              }).setVelocity('.' + op.el, vcOpts.op1, vcOpts.op2);
              scenes.push(scene);
              break;
            case 'middle':
              scene = new $.ScrollMagic.Scene({
                duration: 0,
                offset: ($(document).height() / 2 + op.offset),
                reverse: false
              }).setVelocity('.' + op.el, vcOpts.op1, vcOpts.op2);
              scenes.push(scene);
              break;
            case 'target':
              scene = new $.ScrollMagic.Scene({
                duration: 0,
                triggerElement: op.element,
                reverse: false
              }).setVelocity('.' + op.el, vcOpts.op1, vcOpts.op2);
              scenes.push(scene);
              break;
          }
        }
      }
    }

    const xaFixed = samProOptions.xaFixed;
    $('.sp-button-close').on('click', (e) => {
      $(e.currentTarget).parent().parent().hide(500);
      return false;
    });
    animateFixed(xaFixed.topLeft, tlScene);
    animateFixed(xaFixed.middleLeft, mlScene);
    animateFixed(xaFixed.bottomLeft, blScene);
    animateFixed(xaFixed.topRight, trScene);
    animateFixed(xaFixed.middleRight, mrScene);
    animateFixed(xaFixed.bottomRight, brScene);

    if (xaFixed.bottomMiddle.enabled) {
      const bmTarget = $('.' + xaFixed.bottomMiddle.el);
      const vcOpts = (xaFixed.bottomMiddle.animation === 'fadeIn') ? {
        op1: "fadeIn",
        op2: {
          display: 'flex',
          duration: xaFixed.bottomMiddle.duration,
          delay: xaFixed.bottomMiddle.delay
        }
      } : {
        op1: {translateY: -1000},
        op2: {
          display: 'flex',
          duration: xaFixed.bottomMiddle.duration,
          delay: xaFixed.bottomMiddle.delay
        }
      };
      $('.sp-fixed-bottom-wrapper').each(() => {
        const width = parseInt($(this).data('width'), 10) + 27;
        const height = parseInt($(this).data('height'), 10);
        const winWidth = parseInt($(window).width(), 10);
        if (width < winWidth) $(this).css('width', width);
      });
      if (xaFixed.bottomMiddle.event === 'immediately') {
        switch (xaFixed.bottomMiddle.animation) {
          case 'fadeIn':
            bmTarget.velocity("fadeIn", {
              display: 'flex',
              duration: xaFixed.bottomMiddle.duration,
              delay: xaFixed.bottomMiddle.delay
            });
            break;
          case 'vertical':
            bmTarget.velocity({translateY: -1000}, {
              display: 'flex',
              duration: xaFixed.bottomMiddle.duration,
              delay: xaFixed.bottomMiddle.delay
            });
            break;
        }
      }
      else {
        switch (xaFixed.bottomMiddle.event) {
          case 'scroll':
            bmScene = new $.ScrollMagic.Scene({
              duration: 0,
              offset: xaFixed.bottomMiddle.offset,
              reverse: false
            })
              .setVelocity('.' + xaFixed.bottomMiddle.el, vcOpts.op1, vcOpts.op2);
            scenes.push(bmScene);
            break;
          case 'middle':
            bmScene = new $.ScrollMagic.Scene({
              duration: 0,
              offset: ($(document).height() / 2 + xaFixed.bottomMiddle.offset),
              reverse: false
            })
              .setVelocity('.' + xaFixed.bottomMiddle.el, vcOpts.op1, vcOpts.op2);
            scenes.push(bmScene);
            break;
          case 'target':
            bmScene = new $.ScrollMagic.Scene({
              duration: 0,
              triggerElement: xaFixed.bottomMiddle.element,
              reverse: false
            })
              .setVelocity('.' + xaFixed.bottomMiddle.el, vcOpts.op1, vcOpts.op2);
            scenes.push(bmScene);
            break;
        }
      }
    }

    // Popup Ad
    const xaPopup = samProOptions.xaPopup;
    if (xaPopup.enabled) {
      if (xaPopup.event === 'immediately') {
        $('.sp-popup-dialog').velocity("fadeIn", {
          display: 'flex',
          duration: xaPopup.duration,
          visibility: "visible",
          delay: xaPopup.delay
        });
      }
      else {
        switch (xaPopup.event) {
          case 'scroll':
            ppScene = new $.ScrollMagic.Scene({
              duration: 0,
              offset: xaPopup.offset,
              reverse: false
            })
              .setVelocity('.sp-popup-dialog', {opacity: 1}, {
                visibility: "visible",
                duration: xaPopup.duration,
                display: 'flex'
              });
            scenes.push(ppScene);
            break;
          case 'middle':
            ppScene = new $.ScrollMagic.Scene({
              duration: 0,
              offset: ($(document).height() / 2 + xaPopup.offset),
              reverse: false
            })
              .setVelocity('.sp-popup-dialog', {opacity: 1}, {
                visibility: "visible",
                duration: xaPopup.duration,
                display: 'flex'
              });
            scenes.push(ppScene);
            break;
          case 'target':
            ppScene = new $.ScrollMagic.Scene({
              duration: 0,
              triggerElement: xaPopup.element,
              reverse: false
            })
              .setVelocity('.sp-popup-dialog', {opacity: 1}, {
                visibility: "visible",
                duration: xaPopup.duration,
                display: 'flex'
              });
            scenes.push(ppScene);
            break;
        }
      }
    }

    if (scenes.length > 0) controller.addScene(scenes);
  });
})(jQuery);
